import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFlash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.1115 23C10.9956 22.9998 10.8805 22.9795 10.7715 22.94C10.5613 22.863 10.3829 22.7177 10.2651 22.5273C10.1472 22.3369 10.0967 22.1125 10.1215 21.89L10.8915 14.8H5.00151C4.81984 14.8002 4.64153 14.751 4.48572 14.6576C4.32992 14.5642 4.20251 14.4301 4.11718 14.2697C4.03185 14.1093 3.99182 13.9287 4.00139 13.7473C4.01096 13.5659 4.06977 13.3905 4.17151 13.24L12.0615 1.43998C12.1863 1.25531 12.3692 1.11763 12.5812 1.04878C12.7931 0.979939 13.022 0.983877 13.2315 1.05997C13.4329 1.13474 13.6048 1.27236 13.7219 1.45246C13.839 1.63257 13.8949 1.84559 13.8815 2.05998L13.1115 9.19998H19.0015C19.1832 9.1997 19.3615 9.24892 19.5173 9.34235C19.6731 9.43578 19.8005 9.56989 19.8858 9.73027C19.9712 9.89065 20.0112 10.0712 20.0016 10.2527C19.9921 10.4341 19.9332 10.6095 19.8315 10.76L11.9415 22.56C11.8498 22.6957 11.7261 22.8068 11.5814 22.8835C11.4367 22.9602 11.2753 23.0002 11.1115 23Z",
		fill: "currentColor"
	})
});
export default SvgIconFlash;
